import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ReactLinkify from "react-linkify";
import EpOverlayLoader from "../common/EpOverlayLoader";
import SelectInput from "../common/SelectInput";
import TopNavigation from "../common/TopNavigation";
import { getEmbassyInstructions } from "../utilities/utilities";


function SelectEmbassy(props) {
  const { values, errors, dirty, handleOnChange, setData, navigation, t, } = props;
  const [embassyLookup, setEmbassyLookup] = useState([]);
  const [serviceTypeLookup, setServiceTypeLookup] = useState([]);
  const [citizenLookup, setCitizenLookup] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isParamCode, setParamCode] = useState(false);
  const [isSelectedCitizen, setIsSelectedCitizen] = useState(true);
  const [citizenEnDesc, setCitizenEnDesc] = useState("");
  const [citizenArDesc, setCitizenArDesc] = useState('');
  const { embassycode } = useParams();
  const [modalShow, setModalShow] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorModalShow, setErrorModalShow] = React.useState(false);

  useEffect(() => {

    const queryParams = new URLSearchParams(window.location.search);
    const service = queryParams.get('service');
    const dgRefnumber = queryParams.get('dg-refnumber'); 
  
    if(dgRefnumber){
      //call decrypt api to get the refnumber , service and embassy code...
      fetch(
        process.env.REACT_APP_PRODUCTS_API_BASE_URL + "/services/embassy/api/Embassies/DecryptLink?request="+ dgRefnumber
      )
        .then((response) => {          
          return response.json();
        })
        .then((data) => {
          
          if(data){
            setData({ name: "refnumber", value: data.refNumber });
            setData({ name: "servicecode", value: data.service });       
            setData({ name: "accountNumber", value: data.accountNumber });
          
            if (data.service) {
              getEmbassyInformation(embassycode, data.service, true);             
              return
            }
             setErrorMessage("");
          }
        })
        .catch((error) => {          
          setErrorMessage("The link is invalid or used before. Please try again or contact support ");
          setErrorModalShow(true);
        });
    }

    if (values.embassyServiceList) {
      setServiceTypeLookup(values.embassyServiceList);
    }

    if (values.citizenList) {
      setCitizenLookup(values.citizenList);
    }

    if (embassycode) {
      setParamCode(true);
      getEmabassyServices(embassycode.toUpperCase());
      setData({ "name": "isParmEmbassyCode", value: true });
    }
    else {
      setParamCode(false);
      fetch(
        process.env.REACT_APP_PRODUCTS_API_BASE_URL + "/services/embassy/api/Embassies/list"
      )
        .then((response) => response.json())
        .then((data) => {
          setEmbassyLookup(data.list);
        });
    }
  }, []);


  const mapCitizenCondition = (descriptions) => {

    var text = descriptions.map((item, i) => {
      return <div>
        <h4>{item.title}</h4>
        <ol>

          {item.text.split('\n').map((text, j) => {
            return (text.substring(0, 1) !== "*") ? <li>{text}</li> :
              (
                <div className="instruction-detail">
                  <img className="instruction-warning" src="./images/warning-blue.svg" alt="payment success" />
                  {text.substring(1)}
                </div>
              )
          })}
        </ol>
      </div>
    })
    return (
      <>
        {text}
      </>)


  }

  const getCitizens = (serviceCode) => {

    setLoading(true);
    fetch(
      process.env.REACT_APP_PRODUCTS_API_BASE_URL + "/services/embassy/api/Citizens/" + serviceCode
    )
      .then((response) => response.json())
      .then((data) => {
        setCitizenLookup(data);
        setData({ "name": "citizenList", value: data });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });

  }

  const getEmabassyServices = (embassyCode) => {

    setLoading(true);
    fetch(
      process.env.REACT_APP_PRODUCTS_API_BASE_URL + "/services/embassy/api/EmbassieServices/" + embassyCode
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.length == 0) {
          console.log('The embassy is not available!')
          setLoading(false);
          navigation.go('embassy-not-available');
       
        }

        setServiceTypeLookup(data);
        setData({ "name": "embassyServiceList", value: data });
        setData({ "name": "embassyTitleAr", value: data[0].embassyNameAr });
        setData({ "name": "embassyTitleEn", value: data[0].embassyNameEn });

        setData({ "name": "en_embassyDescriptions", value: null });
        setData({ "name": "ar_embassyDescriptions", value: null });
        setData({ "name": "showCitizens", value: 0 });
        setIsSelectedCitizen(true)

        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });

  }

  const getEmbassyInformation = (embassyCode, servicetypeCode, navigationNext = false) => {

    setLoading(true);
    fetch(
      process.env.REACT_APP_PRODUCTS_API_BASE_URL + "/services/embassy/api/Embassies/" + embassyCode + "/" + servicetypeCode
    )
      .then((response) => response.json())
      .then((data) => {
        const {
          ShowNationalIdNumber, ShowPassportNumber, ShowReceiptNumber,
          ShowReferenceNumber, ShowFirstName, ShowLastName,
          ShowThirdName, ShowSecondName, ShowNotes,
          ShowDateCollect, IsDelivery, IsAttestationService, ShowAlreadyAttestedOption,
          ShowAttestationTypeList, ShowAttestationDescription, HideEmirateIds,
          ShowCitizens, UploadDocument, ShowExpiryDate, IsOnlinePayment, CashPaymentEmirateCodes, IgnorUploadEmirateCodes,
          ShowOccupation,
          ShowDateOfBirth,
          ShowPassportIssueDate,
          ShowPurposeVisit,
          ShowNationality,
          ShowPassportType,
          ShowAcknowledgment
        } = data.configrations;

        const configuration = {
          showNationalIdNumber: parseInt(ShowNationalIdNumber),
          showPassportNumber: parseInt(ShowPassportNumber),
          showReceiptNumber: parseInt(ShowReceiptNumber),
          showReferenceNumber: parseInt(ShowReferenceNumber),
          showFirstName: parseInt(ShowFirstName),
          showLastName: parseInt(ShowLastName),
          showThirdName: parseInt(ShowThirdName),
          showSecondName: parseInt(ShowSecondName),
          showNotes: parseInt(ShowNotes),
          showDateCollect: ShowDateCollect ? parseInt(ShowDateCollect) : 0,
          isDelivery: IsDelivery ? parseInt(IsDelivery) : 0,
          isAttestationService: IsAttestationService ? parseInt(IsAttestationService) : 0,
          showAlreadyAttestedOption: ShowAlreadyAttestedOption ? parseInt(ShowAlreadyAttestedOption) : 0,
          showAttestationTypeList: ShowAttestationTypeList ? parseInt(ShowAttestationTypeList) : 0,
          showAttestationDescription: ShowAttestationDescription ? parseInt(ShowAttestationDescription) : 0,
          cashPaymentEmirateCodes: CashPaymentEmirateCodes ? CashPaymentEmirateCodes.split(",") : null,
          ignorUploadEmirateCodes: IgnorUploadEmirateCodes ? IgnorUploadEmirateCodes.split(",") : null,
          showCitizens: ShowCitizens ? parseInt(ShowCitizens) : 0,
          uploadDocument: UploadDocument ? parseInt(UploadDocument) : 0,
          showExpiryDate: ShowExpiryDate ? parseInt(ShowExpiryDate) : 0,
          hideEmirateIds: HideEmirateIds,
          isOnlinePayment: IsOnlinePayment,
          showOccupation: ShowOccupation ? parseInt(ShowOccupation) : 0,
          showDateOfBirth: ShowDateOfBirth ? parseInt(ShowDateOfBirth) : 0,
          showPassportIssueDate: ShowPassportIssueDate ? parseInt(ShowPassportIssueDate) : 0,
          showPurposeVisit: ShowPurposeVisit ? parseInt(ShowPurposeVisit) : 0,
          showNationality: ShowNationality ? parseInt(ShowNationality) : 0,
          showPassportType: ShowPassportType ? parseInt(ShowPassportType) : 0,
          showAcknowledgment: ShowAcknowledgment ? parseInt(ShowAcknowledgment) : 0

        };

       
        var calculatedTotal = 0;
        if (IsAttestationService == 0) {
          setData({ "name": "amount", "value": data.productInfo[0].deliveryFees });
          setData({ "name": "vat", "value": data.productInfo[0].vat });
          calculatedTotal = (parseFloat(data.productInfo[0].deliveryFees) + parseFloat(data.productInfo[0].vat)).toFixed(2);
        }

        setData({ "name": "numberOfDocument", value: 1 });
        setData({ "name": "maxDocumentSelected", value: false });
        setData({ "name": "embassyConfiguration", value: data.configrations });
        setData({ "name": "configuration", value: configuration });
        setData({ "name": "paymentOptions", value: data.paymentOptions });

        setData({ "name": "embassyNameEn", "value": data.nameEn });
        setData({ "name": "embassyNameAr", "value": data.nameAr });
        setData({ "name": "embassyLogo", "value": data.logoBase64 });
        setData({ "name": "rigthSideImage", "value": data.rightSideImageBase64 });
        setData({ "name": "embassyDescriptionAR", "value": data.descriptionAr });
        setData({ "name": "embassyDescriptionEN", "value": data.descriptionEn });
        setData({ "name": "acknowledgmentMessage", "value": data.acknowledgmentMessage });
        setData({ "name": "embassyDescriptionOther", "value": data.description });
        setData({ "name": "totalAmount", "value": calculatedTotal });
        setData({ "name": "productInfo", "value": data.productInfo });
        setData({ "name": "isOnlinePayment", "value": data.isOnlinePayment });
        setData({ "name": "cashPaymentEmitateCodes", "value": configuration.cashPaymentEmirateCodes });
        setData({ "name": "ignorUploadEmirateCodes", "value": configuration.ignorUploadEmirateCodes });
        setData({ "name": "showCitizens", "value": ShowCitizens });
        setIsSelectedCitizen(ShowCitizens != 1);
        setData({ "name": "showAcknowledgment", "value": configuration.showAcknowledgment });

        //mappingCitizenItems(data.citizensNameEn, data.citizensNameAr);

        setData({ "name": "ar_embassyDescriptions", "value": data.arDescriptions });
        setData({ "name": "en_embassyDescriptions", "value": data.enDescriptions });

        setData({ "name": "isAttestationService", "value": IsAttestationService });
        setData({ "name": "embassyCode", value: embassycode.toUpperCase() });
        setData({ "name": "selectedEmbassyCode", value: embassycode.toUpperCase() });
        setData({ "name": "selectedServiceTypeCode", value: servicetypeCode });
        setData({ "name": "serviceTypeCode", value: servicetypeCode });
        setData({ name: "showUploadDocument", value: 0 });

        
        if (embassycode)
          setData({ "name": "isParmEmbassyCode", value: true });
        else
          setData({ "name": "isParmEmbassyCode", value: false });
        setLoading(false);

        if (navigationNext) {
         
          setData({ name: "attestationNatureCode", value: "PA" });
          setData({ name: "alreadyAttested",value: true });
          setData({ name: "serviceTypeName", value: "Attestation Service" });
          setData({ "name": "attestationNatureName", value: "Personal Attestation" });
          setData({ "name": "SpecialNotes", value: "Any other personal certificates or documents" });

          data.productInfo.forEach(item => {
            if (item.attestationCode === "PA" && item.serviceCharges == 0) {
              setData({ "name": "amount", value: item.deliveryFees });
              setData({ "name": "attestationServiceCharges", value: item.serviceCharges });
              setData({ "name": "vat", value: item.vat });
              const calculatedTotal = (parseFloat(item.deliveryFees) + (parseFloat(item.serviceCharges)) + parseFloat(item.vat)).toFixed(2);

              setData({ "name": "totalAmount", value: calculatedTotal });
            }
          })

          navigation.go('address-details');
        }


      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }

  const embassyChangeHandler = (event) => {

    const selectedEmbassyCode = event.target.value
    setData({ "name": "alreadyAttested", value: false });
    setData({ "name": "selectedEmbassyCode", value: selectedEmbassyCode });
    setData({ "name": "embassyCode", value: selectedEmbassyCode });

    handleOnChange(event);

    setData({ "name": "selectedServiceTypeCode", value: '' });
    setData({ "name": "serviceTypeCode", value: '' });
    setData({ name: "citizenName", value: "" });
    getEmabassyServices(selectedEmbassyCode);
    setIsSelectedCitizen(true);

  }

  const citizenItemChangeHandler = (event) => {

    const citizenCode = event.target.value;
    var selectedCitizen = values.citizenList.find(x => x.code == citizenCode);
    setData({ "name": "citizenName", value: citizenCode });
    setData({ "name": "nationality", value: values.locale == "en" ? selectedCitizen.nationalityEn : selectedCitizen.nationalityAr });
    if (selectedCitizen.enDescriptions) {
      var enDesc = mapCitizenCondition(selectedCitizen.enDescriptions);
      var arDesc = mapCitizenCondition(selectedCitizen.arDescriptions);
      setCitizenEnDesc(enDesc);
      setCitizenArDesc(arDesc);
      setModalShow(true);
    }

    //setData({ "name": "en_citizen_Descriptions", "value": selectedCitizen.enDescriptions });
    //setData({ "name": "ar_citizen_Descriptions", "value": selectedCitizen.arDescriptions });
    setIsSelectedCitizen(true);
  }

  const handlCloseModal = () => {
    setModalShow(false);
  };

  const handlCloseErrorModal = () => {
    setErrorModalShow(false);
  }
  const serviceTypeChangeHandler = (event) => {

    const selectedServiceTypeCode = event.target.value;
    var index = event.nativeEvent.target.selectedIndex;
    if (selectedServiceTypeCode) {
      setData({ "name": "selectedServiceTypeCode", value: selectedServiceTypeCode });
      setData({ "name": "serviceTypeCode", value: selectedServiceTypeCode });
      setData({ "name": "serviceTypeName", value: event.target[index].text });

      handleOnChange(event);
      if (embassycode)
        getEmbassyInformation(embassycode, selectedServiceTypeCode);
      else
        getEmbassyInformation(values.embassyCode, selectedServiceTypeCode);

      setData({ "name": "showCitizens", value: 0 });
      setData({ name: "citizenName", value: "" });
      setData({ name: "documentBase64", value: null });
      setData({ name: "showUploadDocument", value: 0 });
      setIsSelectedCitizen(true);

      getCitizens(selectedServiceTypeCode);

    }
  }

  const citizenSelectionValid = values.showCitizens != 1 || values.citizenName;

  return (

    <>
      <Modal
        show={modalShow}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          {values.locale == "en" ? citizenEnDesc : citizenArDesc}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlCloseModal}>
            {t('CLOSE')}
          </Button>
        </Modal.Footer>
      </Modal>

   <Modal
        show={errorModalShow}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body> 
         
           <div className="d-flex flex-column justify-content-center align-items-center text-center py-4">
            <img
              src="./images/payment-failure.svg"
              alt="invalid link"
              className="invalid-link mb-3"
            />
            <h4>{errorMessage}</h4>
        </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlCloseErrorModal}>
            {t('CLOSE')}
          </Button>
        </Modal.Footer>
      </Modal>

      <div>
        <div className="container-md">
          <div className="top-section">
            <TopNavigation {...props} />
          </div>
          <div className="mid-selection mt-4">
            <div className="row align-items-center">
              <div className="col-sm-5">
                <div className="embassy-section">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        <div className="col-sm-12">
                          <img
                            src="images/embassy-icon.svg"
                            alt="Embassy Icon"
                            width={40}
                            className="mb-2"
                          />
                          <div className="consulate-selection mb-4 pb-3 mt-2">
                            <h2>{t("EMIRATESPOST_CONSULATE_SERVICE")}</h2>
                            <h5>{values.locale == "ar" ? values.embassyTitleAr : values.embassyTitleEn}</h5>

                            {!isParamCode && <p className="sub-head">
                              {t("CONSULATE_SERVICE_DESCRIPTION")}
                            </p>}
                          </div>

                          {isParamCode === false && <div className="row">
                            <h4>{t("PLEASE_SELECT_YOUR_EMBASSY")}</h4>
                            <div className="col-sm-8 mt-2">
                              <SelectInput
                                className="form-control form-select"
                                id="embassyCode"
                                name="embassyCode"
                                label=""
                                onChange={embassyChangeHandler}
                                value={values.embassyCode}
                                validation={{ errors, dirty }}
                                defaultText={t("SELECT_THE_EMBASSY")}
                                itemLookUp={embassyLookup}
                                language={values.locale}
                                t={t}
                              />
                            </div>
                          </div>


                          }
                          <h4></h4>
                          <div className="row">
                            <h4>{t("PLEASE_SELECT_THE_SERVICE")}</h4>
                            <div className="col-sm-8 mt-2 mb-3">
                              <SelectInput
                                className="form-control form-select"
                                id="serviceTypeCode"
                                name="serviceTypeCode"
                                label=""
                                value={values.serviceTypeCode}
                                validation={{ errors, dirty }}
                                onChange={serviceTypeChangeHandler}
                                defaultText={t("SELECT_THE_SERVICE")}
                                itemLookUp={serviceTypeLookup}
                                language={values.locale}
                                t={t}
                              />
                            </div>
                          </div>

                          {values.showCitizens == 1 && <div className="row">
                            <h4>{t("PLEASE_SELECT_THE_CITIZEN")}</h4>
                            <div className="col-sm-8 mt-2 mb-3">
                              <SelectInput
                                className="form-control form-select"
                                id="citizenName"
                                name="citizenName"
                                label=""
                                value={values.citizenName}
                                onChange={citizenItemChangeHandler}
                                defaultText={t("SELECT_THE_CITIZEN")}
                                itemLookUp={citizenLookup}
                                language={values.locale}
                                t={t}
                              />
                            </div>
                          </div>}


                          {(values.embassyCode !== "" || embassycode !== "") && (
                            <div className="row ">
                              <div className="col-sm-12 mt-3">
                                <ReactLinkify>{getEmbassyInstructions(values.en_embassyDescriptions, values.ar_embassyDescriptions, t("INSTRUCTIONS_TITLE"), values.locale, t("JORDAN_SPECIFIC_INSTRUCTION"), values.embassyCode)}</ReactLinkify>
                                <ReactLinkify>{getEmbassyInstructions(values.en_citizen_Descriptions, values.ar_citizen_Descriptions, '', values.locale, '', values.embassyCode)}</ReactLinkify>

                              </div>
                            </div>
                          )}
                        </div>
                        <div className="col-sm-12 mt-4">
                          <button
                            className="btn btn-primary btn-lg emx-button"
                            disabled={
                              !(values.serviceTypeCode
                                && citizenSelectionValid
                                && (values.embassyCode !== "" || (isParamCode && embassycode))
                                && !isLoading)
                            }
                            onClick={() => {
                              if (values.serviceTypeCode === "ATTEST") navigation.next();
                              else if (values.serviceTypeCode === "GOOD") navigation.go("contact-verification");
                              else navigation.go("address-details");
                            }}
                          >
                            {t("PROCEED")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-1">&nbsp;</div>

              {isParamCode === true &&

                <div className="col-sm-6">
                  <div>
                    <img
                      src={`images/${embassycode.toLowerCase()}.png`}
                      alt="attestation_image"
                      className="rigth-side-image"
                    />
                  </div>
                </div>
              }
              {isParamCode === false &&
                <div className="col-sm-6">
                  <div className="passport-sec">
                    <img
                      src="images/passport-image.svg"
                      alt="passport_image"
                      className="main-image"
                    />
                  </div>
                </div>
              }



            </div>
            <div className="row column my-3"></div>
          </div>
        </div>
        {/* <EpInlineLoader /> */}
        {isLoading && <EpOverlayLoader text={t("LOADING_PLEASE_WAIT")} />}
      </div>
    </>
  );
}

export default SelectEmbassy;